export default function FinalCTA() {
  return (
    <section className="py-16 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-8 lg:px-12 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white">
          Ready to Explore the AllChinaBuy Spreadsheet?
        </h2>
        <p className="mt-4 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          Start with the spreadsheet, compare your options, learn how the buying process works, and use our guides to make more informed decisions.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-primary-600 font-medium rounded-lg hover:bg-white/90 transition-colors"
          >
            Explore AllChinaBuy Spreadsheet
            <i className="ri-external-link-line" />
          </a>
          <a
            href="/allchinabuy-spreadsheet-guide/"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 text-white font-medium rounded-lg border border-white/20 hover:bg-white/20 transition-colors"
          >
            Read Guide
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}